import React from 'react'
import Layout from '../components/Layout'
import RichText from '../components/RichText'

export default function Contato({ content, email, contactImage }) {
  return (
    <Layout fullWidth noFooter>
      <div className="min-h-[calc(100vh-70px)] bg-brand-dark flex flex-col md:flex-row">
        <div className="md:w-1/2 h-[40vh] md:h-auto">
          <img src={contactImage} alt="Contato" className="w-full h-full object-cover" />
        </div>

        <div className="md:w-1/2 flex items-center justify-center text-white p-8">
          <div className="text-center">
            <RichText content={content} className="text-brand-light font-bold text-xl md:text-2xl mb-4" invert />
            <p className="text-lg">{email}</p>
          </div>
        </div>
      </div>
    </Layout>
  )
}
